"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsExtensionsSettingsDialogStyles = void 0;
var typestyle_1 = require("typestyle");
var cssPrefix = 'AnalyticsExtensionsSettingsDialog';
function cssClass(prefix, name) {
    var styles = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        styles[_i - 2] = arguments[_i];
    }
    return typestyle_1.style.apply(void 0, __spreadArrays(styles, [{
            $debugName: prefix + "_" + name,
            $unique: true,
        }]));
}
var AnalyticsExtensionsSettingsDialogStyles;
(function (AnalyticsExtensionsSettingsDialogStyles) {
    var defaultLetterSpacing = '0.2px';
    var defaultFontColor = '#4F4F4F';
    var defaultFontSize = 'TabStyles.Typography.Sizing.Default px';
    AnalyticsExtensionsSettingsDialogStyles.root = cssClass(cssPrefix, 'root', {
        backgroundColor: defaultFontColor,
        fontSize: defaultFontSize,
    });
    AnalyticsExtensionsSettingsDialogStyles.hide = cssClass(cssPrefix, 'hide', {
        display: 'none',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryScreenContainer = cssClass(cssPrefix, 'einstein-discovery-screen-container', {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryIcon = cssClass(cssPrefix, 'einstein-discovery-icon', {
        width: '80px',
        height: '80px',
        marginTop: '14px',
        borderRadius: '40px',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryInfoContainer = cssClass(cssPrefix, 'einstein-discovery-info-container', {
        display: 'flex',
        alignSelf: 'center',
        height: '173px',
        flexDirection: 'column',
        alignItems: 'center',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryHeaderText = cssClass(cssPrefix, 'einstein-discovery-header-text', {
        fontFamily: 'Benton Sans',
        fontSize: '16px',
        letterSpacing: defaultLetterSpacing,
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDescriptionTextContainer = cssClass(cssPrefix, 'einstein-discovery-description-text-container', {
        display: 'flex',
        marginTop: '12px',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDisclaimerTextContainer = cssClass(cssPrefix, 'einstein-discovery-disclaimer-text-container', {
        display: 'flex',
        marginTop: '8px',
        width: 339,
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDescriptionText = cssClass(cssPrefix, 'einstein-discovery-description-text', {
        fontFamily: 'Benton Sans',
        fontSize: defaultFontSize,
        letterSpacing: defaultLetterSpacing,
        color: defaultFontColor,
        marginTop: 5,
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryDisclaimerText = cssClass(cssPrefix, 'einstein-discovery-disclaimer-text', {
        fontFamily: 'Benton Sans',
        fontSize: '9px',
        color: '#858585',
        textAlign: 'center',
        fontStyle: 'italic',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessContainer = cssClass(cssPrefix, 'einstein-discovery-enabled-success-container', {
        width: '284px',
        marginTop: '16px',
        backgroundColor: '#F2F8F6',
        display: 'flex',
        alignItems: 'center',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessVerticalBar = cssClass(cssPrefix, 'einstein-discovery-enabled-success-vertical-bar', {
        backgroundColor: '#008057',
        height: '100%',
        width: '4px',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessCheckmark = cssClass(cssPrefix, 'einstein-discovery-enabled-success-checkmark', {
        width: '10px',
        height: '10px',
        marginLeft: '7px',
        color: '#008057',
        paddingBottom: '8px',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryEnabledSuccessDescriptionText = cssClass(cssPrefix, 'einsteinDiscovery-enabled-success-description-text', {
        fontFamily: 'Benton Sans',
        fontSize: defaultFontSize,
        letterSpacing: defaultLetterSpacing,
        marginLeft: '7px',
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryButtonsContainer = cssClass(cssPrefix, 'einstein-discovery-buttons-container', {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '408px',
        alignSelf: 'flex-end',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryTestConnectionButtonContainer = cssClass(cssPrefix, 'einstein-discovery-test-connection-button-container', {
        alignSelf: 'flex-end',
        flexDirection: 'column',
        display: 'flex',
        width: '150px',
        marginRight: '10px',
        marginLeft: '45px',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryBackButtonContainer = cssClass(cssPrefix, 'einstein-discovery-back-button-container', {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryCancelButtonContainer = cssClass(cssPrefix, 'einstein-discovery-cancel-button-container', {
        width: '40px',
        marginRight: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    });
    AnalyticsExtensionsSettingsDialogStyles.einsteinDiscoveryActivitySpinner = cssClass(cssPrefix, 'einstein-discovery-activity-spinner', {
        paddingTop: '2px',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuScreen = cssClass(cssPrefix, 'menu-screen', {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuHeaderTextContainer = cssClass(cssPrefix, 'menu-header-text-container', {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuSelectionContainer = cssClass(cssPrefix, 'menu-selection-container', {
        border: 'solid 1px',
        borderColor: '#CBCBCB',
        marginTop: '20px',
        boxSizing: 'border-box',
        width: '430px',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuHeaderText = cssClass(cssPrefix, 'menu-header-text', {
        fontFamily: 'Benton Sans',
        fontSize: '16px',
        letterSpacing: defaultLetterSpacing,
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.menuHeaderSubtext = cssClass(cssPrefix, 'menu-header-subtext', {
        fontFamily: 'Benton Sans',
        fontSize: defaultFontSize,
        letterSpacing: defaultLetterSpacing,
        color: defaultFontColor,
        marginTop: '14px',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuButtonContainer = cssClass(cssPrefix, 'menu-button-container', {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '29px',
        paddingRight: '3px',
        outline: 'none',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuOptionContainer = cssClass(cssPrefix, 'menu-option-container', {
        transitionDuration: '0.1s',
        display: 'flex',
        flexDirection: 'row',
        marginTop: '10px',
        marginBottom: '10px',
        border: '0px',
        backgroundColor: 'white',
        $nest: {
            '&:hover': {
                backgroundColor: '#EEEEEE',
            },
        },
    });
    AnalyticsExtensionsSettingsDialogStyles.menuButtonImage = cssClass(cssPrefix, 'menu-button-image', {
        width: '80px',
        height: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '40px',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuButtonImageText = cssClass(cssPrefix, 'menu-button-image-text', {
        color: 'white',
        fontFamily: 'Benton Sans',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuButtonTextContainer = cssClass(cssPrefix, 'menu-button-text-container', {
        marginLeft: '17px',
        height: '70px',
        width: '290px',
        alignSelf: 'flex-end',
        flexDirection: 'column',
        display: 'flex',
    });
    AnalyticsExtensionsSettingsDialogStyles.menuButtonTitleText = cssClass(cssPrefix, 'menu-button-title-text', {
        fontSize: defaultFontSize,
        fontFamily: 'Benton Sans',
        letterSpacing: defaultLetterSpacing,
        fontWeight: 'bold',
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.menuButtonDescriptionText = cssClass(cssPrefix, 'menu-button-description-text', {
        fontSize: defaultFontSize,
        fontFamily: 'Benton Sans',
        letterSpacing: defaultLetterSpacing,
        marginTop: '2px',
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.flex = cssClass(cssPrefix, 'flex', {
        display: 'flex',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenContainer = cssClass(cssPrefix, 'connection-screen-container', {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenIconContainer = cssClass(cssPrefix, 'connection-screen-icon-container', {
        marginTop: '7px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '80px',
        height: '80px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenTitleText = cssClass(cssPrefix, 'connection-screen-title-text', {
        fontSize: '16px',
        marginTop: '25px',
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenConnectionNameContainer = cssClass(cssPrefix, 'connection-screen-connection-name-container', {
        marginTop: '25px',
        height: '60px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenRequireSSLContainer = cssClass(cssPrefix, 'connection-screen-require-ssl-container', {
        width: '410px',
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: '4px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenHostAndPortContainer = cssClass(cssPrefix, 'connection-screen-host-and-port-container', {
        display: 'flex',
        justifyContent: 'space-between',
        width: '410px',
        height: '62px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenSignInWithUsernameAndPasswordContainer = cssClass(cssPrefix, 'connection-screen-sign-in-with-username-and-password-container', {
        width: '410px',
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: '2px',
        marginBottom: '4px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenUsernameAndPasswordContainer = cssClass(cssPrefix, 'connection-screen-username-and-password-container', {
        display: 'flex',
        justifyContent: 'space-between',
        width: '410px',
        height: '62px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenButtonsContainer = cssClass(cssPrefix, 'connection-screen-buttons-container', {
        width: '410px',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '7px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenBackButtonContainer = cssClass(cssPrefix, 'connection-screen-back-button-container', {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    });
    AnalyticsExtensionsSettingsDialogStyles.withSpaceHolder = cssClass(cssPrefix, 'with-space-holder', {
        width: '200px',
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: '200px',
    });
    AnalyticsExtensionsSettingsDialogStyles.withLargeSpaceHolder = cssClass(cssPrefix, 'with-space-holder', {
        width: '200px',
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: '300px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenCancelButtonContainer = cssClass(cssPrefix, 'connection-screen-cancel-button-container', {
        display: 'flex',
        justifyContent: 'space-between',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenOKButtonContainer = cssClass(cssPrefix, 'connection-screen-ok-button-container', {
        display: 'flex',
        marginLeft: '15px',
        justifyContent: 'space-between',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenBackTickPadding = cssClass(cssPrefix, 'connection-screen-back-tick-padding', {
        paddingBottom: '2px',
        paddingRight: '2px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenHttpsLabel = cssClass(cssPrefix, 'connection-screen-https-label', {
        paddingTop: '26px',
        width: '45px',
        marginRight: '15px',
        color: defaultFontColor,
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenPortContainer = cssClass(cssPrefix, 'connection-screen-port-container', {
        marginLeft: '20px',
    });
    AnalyticsExtensionsSettingsDialogStyles.connectionScreenCreateButtonContainer = cssClass(cssPrefix, 'connection-screen-create-button-container', {
        marginLeft: '10px',
    });
})(AnalyticsExtensionsSettingsDialogStyles = exports.AnalyticsExtensionsSettingsDialogStyles || (exports.AnalyticsExtensionsSettingsDialogStyles = {}));
//# sourceMappingURL=AnalyticsExtensionsSettingsDialogStyles.js.map